import {
  Ship,
  Anchor,
  Building2,
  Users,
  Sailboat,
  Waves,
  HardHat,
  Flame,
  Factory,
  Construction,
} from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, ChapterHeading } from "@/components/Reveal";

const icons = [Ship, Anchor, Building2, Users, Sailboat, Waves, HardHat, Flame, Factory, Construction];

const Industries = () => {
  const { t } = useLanguage();

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative overflow-hidden bg-navy py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-20">
        <ChapterHeading number={t.industries.number} title={t.industries.chapter} dark />

        <Reveal>
          <h2
            data-testid="industries-title"
            className="mt-12 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl"
          >
            {t.industries.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {t.industries.items.map((item, i) => {
            const Icon = icons[i % icons.length];
            return (
              <Reveal key={item} delay={0.05 * i}>
                <div
                  data-testid={`industry-item-${i}`}
                  className="group flex h-full flex-col gap-4 rounded-xl border border-white/10 bg-white/[0.04] p-6 transition-[background-color,border-color,transform] duration-500 hover:-translate-y-1 hover:border-gold/50 hover:bg-white/[0.08]"
                >
                  <Icon className="h-6 w-6 text-gold" aria-hidden="true" />
                  <p className="text-sm font-semibold leading-snug text-white/85">{item}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
